import React, { useMemo, useState } from 'react';
import { assets, legalUpdated, salon } from '../data/content';
import type { LegalDoc } from '../data/copy/types';
import { useLanguage } from '../contexts/LanguageContext';
import { LanguageToggle } from './LanguageToggle';
import { LegalModal } from './LegalModal';
import { InstagramIcon, TikTokIcon } from './icons/GoldIcons';
export function Footer() {
  const {
    t,
    lang
  } = useLanguage();
  const [openDoc, setOpenDoc] = useState<LegalDoc | null>(null);
  const updated = useMemo(() => new Intl.DateTimeFormat(lang === 'es' ? 'es-ES' : 'en-US', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  }).format(new Date(`${legalUpdated}T12:00:00`)), [lang]);
  const legalDocs = [t.legal.privacy, t.legal.terms];
  return <footer className="relative w-full overflow-hidden border-t border-gold-deep/25 bg-black pb-10 pt-20" data-id="element-68" data-mp="3qf9suv9j5ajh">
      <div className="relative mx-auto max-w-6xl px-5 text-center sm:px-8" data-id="element-69" data-mp="2eya1q2yx51r1">
        <img src={assets.logo} alt={t.a11y.logo} className="blend-logo mx-auto h-44 w-auto object-contain sm:h-52" data-id="element-70" data-mp="2ew6z8jgkxg5f" />

        <p className="gold-shine mt-2 font-display text-2xl italic sm:text-3xl" data-id="element-71" data-mp="3gagz5ny8f937">
          “{t.footer.quote}”
        </p>

        <div className="gold-rule mx-auto mt-10 h-px w-56" aria-hidden="true" data-id="element-72" data-mp="3v89dwdvyftgc" />

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-7 gap-y-3" data-id="element-73" data-mp="3q8n0o4g4md7j">
          {t.nav.links.map(link => <li key={link.id} data-id="element-74" data-mp="82idhvaq8efw">
              <a href={`#${link.id}`} className="text-[12px] uppercase tracking-[0.2em] text-neutral-400 transition-colors duration-200 hover:text-gold-bright" data-id="element-75" data-mp="81pe5fe3kr7s">
                {link.label}
              </a>
            </li>)}
        </ul>

        <ul className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[12px] text-neutral-500" data-id="element-76" data-mp="huo3izhf4lsg">
          {t.footer.notes.map(note => <li key={note} data-id="element-77" data-mp="qujm3pdazj2i">{note}</li>)}
        </ul>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-4" data-id="element-78" data-mp="qr5h09d98vrd">
          <a href={salon.instagramHref} target="_blank" rel="noreferrer" aria-label={t.a11y.instagram} className="rounded-full border border-gold-deep/50 p-3 text-gold-soft transition-colors duration-200 hover:border-gold-soft hover:text-gold-ivory" data-id="element-79" data-mp="mtr8kjxees0f">
            <InstagramIcon className="h-5 w-5" strokeWidth={1.5} data-id="element-80" data-mp="13t0uoiz25exu" />
          </a>
          <a href={salon.tiktokHref} target="_blank" rel="noreferrer" aria-label={t.a11y.tiktok} className="rounded-full border border-gold-deep/50 p-3 text-gold-soft transition-colors duration-200 hover:border-gold-soft hover:text-gold-ivory" data-id="element-81" data-mp="18jr0fxbebjt2">
            <TikTokIcon className="h-5 w-5" strokeWidth={1.5} data-id="element-82" data-mp="1hje64vb5rbrx" />
          </a>
          <LanguageToggle data-id="element-83" data-mp="1mjilgi0by0gk" />
        </div>

        <div className="mt-12 border-t border-gold-deep/20 pt-8" data-id="element-84" data-mp="1mhpcgw28v45e">
          <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-85" data-mp="1rhtrsirf1su1">
            {legalDocs.map(doc => <li key={doc.title} data-id="element-86" data-mp="3ocgg8jdo3345">
                <button type="button" onClick={() => setOpenDoc(doc)} className="text-[12px] uppercase tracking-[0.2em] text-neutral-400 underline decoration-gold-deep/50 decoration-1 underline-offset-4 transition-colors duration-200 hover:text-gold-bright hover:decoration-gold-soft focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-soft" data-id="element-87" data-mp="3odhwd29jifsq">
                  {doc.linkLabel}
                </button>
              </li>)}
          </ul>

          <p className="mt-6 text-[12px] uppercase tracking-[0.22em] text-neutral-600" data-id="element-88" data-mp="1wp0b7cj39y0i">
            {t.footer.address}
          </p>
          <p className="mt-2 text-[11px] tracking-[0.14em] text-neutral-700" data-id="element-89" data-mp="2tbvhif5c4av2">
            © {new Date().getFullYear()} La Reina Beauty Salon LLC · {t.footer.rights}
          </p>
        </div>
      </div>

      <LegalModal doc={openDoc} updated={updated} onClose={() => setOpenDoc(null)} data-id="element-90" data-mp="2kf4etjwa1xri" />
    </footer>;
}